import React from 'react'

export default () => {
    return (
        <style>
            {`
            .inputs-for-responsive{
                width: 900px;
                height: 40px;
                padding: 10px;
                border-radius: 4px;
                font-size: 15px;
                display: flex;
                border: 1px solid #989ca8;
            }
            .border-bottom-inside-header-of-table{
                border-bottom: 4px solid;
                padding: 1px;
            }
            .appling-width-btns{
                width:262px;
            }
            .appling-width-btns .image-btn-edit-delete-user-compaign
            {
                height:40px
            }
            .appling-width-btns .btn-of-view-user-compaign
            {
                height: 51px;
            }
           .cursor-pointer.view-btn-of-table {
             width: 119px;
            } 
            `}
        </style>
    );
}